import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

const PaymentState = () => {
  const [paymentStatus, setPaymentStatus] = useState("");
  const [times, setTimes] = useState(10);

  const history = useHistory();

  useEffect(() => {
    window.location.search
      .substring(1)
      .split("&")
      .forEach((item) => {
        let s = item.split("=");
        let key = s[0];
        let value = s[1];
        if (key === "success") {
          setPaymentStatus(value);
        }
      });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (times === 0) {
        history.replace("/");
        clearInterval(timer);
        window.location.href = "/";
      } else {
        setTimes((m) => m - 1);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [times]);

  return (
    <section className="section-payment mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <div className="card">
              <div className="card-header">
                <h4>Payment Status</h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    {paymentStatus === "true" ? (
                      <div className="alert alert-success">
                        <h5>
                          <i className="fa fa-check-circle"></i> Payment
                          Successful
                        </h5>
                        <p>
                          Thank you for your payment. You can now use the
                          package you have purchased.
                        </p>
                      </div>
                    ) : (
                      <div className="alert alert-danger">
                        <h5>
                          <i className="fa fa-times-circle"></i> Payment Failed
                        </h5>
                        <p>
                          Sorry, your payment was not successful. Please try
                          again.
                        </p>
                      </div>
                    )}
                    <h6>
                      <i class="fas fa-clock"></i> {times}s{" "}
                      <span>Remaining to redirect to home page</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentState;
